if (!customElements.get(`hot-spot`)) {
  class HotSpot extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.addEventListener(`click`, (ev) => {
        const clicked_element = ev.target.closest(`[data-action]`);

        if (!clicked_element) {
          return;
        } else {
          ev.preventDefault();
        }

        const {
          action,
        } = clicked_element.dataset;

        switch (action) {
          case `open-popup`:
            const hotspot_buttons = this.querySelectorAll(`[data-hotspot-button]`);
            const popups = this.querySelectorAll(`[data-popup]`);
            const parent_el = clicked_element.parentElement;
            const popup_to_open = parent_el.querySelector(`[data-popup]`);

            hotspot_buttons.forEach(button => {
              if (button === clicked_element) return;
              button.classList.remove(`hotspot-button-active`);
              button.classList.add(`hotspot-button-inactive`);
            });

            if (clicked_element.classList.contains(`hotspot-button-inactive`)) {
              clicked_element.classList.remove(`hotspot-button-inactive`);
              clicked_element.classList.add(`hotspot-button-active`);
            } else {
              clicked_element.classList.add(`hotspot-button-inactive`);
              clicked_element.classList.remove(`hotspot-button-active`);
            }

            popups.forEach(popup => {
              if (popup === popup_to_open) return;
              popup.classList.remove(`popup-active`);
              popup.classList.add(`popup-hidden`);
            });

            if (popup_to_open.classList.contains(`popup-hidden`)) {
              popup_to_open.classList.remove(`popup-hidden`);
              popup_to_open.classList.add(`popup-active`);
            } else {
              popup_to_open.classList.add(`popup-hidden`);
              popup_to_open.classList.remove(`popup-active`);
            }

          break;

          case `open-popup-mobile`:
            const hotspot_buttons_mobile = this.querySelectorAll(`[data-hotspot-button-mobile]`);

            hotspot_buttons_mobile.forEach(button => {
              if (button === clicked_element) return;
              button.classList.remove(`hotspot-button-active`);
              button.classList.add(`hotspot-button-inactive`);
            });

            if (clicked_element.classList.contains(`hotspot-button-inactive`)) {
              clicked_element.classList.remove(`hotspot-button-inactive`);
              clicked_element.classList.add(`hotspot-button-active`);
            } else {
              clicked_element.classList.add(`hotspot-button-inactive`);
              clicked_element.classList.remove(`hotspot-button-active`);
            }

          break;

          default: break;
        }
      });
    }
  }
  
  customElements.define(`hot-spot`, HotSpot);
}
